<div class="p-4 grid grid-cols-[1fr_auto] items-end gap-2 md:gap-2 md:grid-cols-1">
  <lds-field
    [label]="'findACircleKFuelOrEVStation' | translate"
    [aria-label]="'findACircleKFuelOrEVStation' | translate"
  >
    <lds-select
      [ldsClearable]="true"
      [formControl]="select"
      [items]="suggestions()"
      [placeholderIcon]="Icon.SEARCH_MD"
      [placeholder]="'searchByNameAddressEtc' | translate"
      [asyncHandling]="true"
      (search)="onSearch($event)"
      (selected)="onSuggestionSelected($event)"
      bindText="text"
    >
    </lds-select>
  </lds-field>
  <app-stations-filters-button></app-stations-filters-button>
</div>
